import React from "react";
import { useProductionStore } from "../../../stores/production";
import { formatComptableMaisPasTrop } from "../../../services/function";

const TimeSpentPerCustomer = () => {
  const { production2 } = useProductionStore();

  // Récupere toutes les missions, tous clients confondus
  const missions: any[] =
    production2?.clients?.flatMap((client: any) => client?.missions ?? []) ?? [];

  // Récupere tous les utilisateurs uniques
  const users: string[] = missions.flatMap((mission: any) =>
    mission.months.flatMap((month: any) =>
      month.collabs.map((collab: any) => collab.name)
    )
  );
  const uniqueUsers = [...new Set(users)];

  // Récupere tous les totaux uniques
  const totaux: string[] = missions.flatMap((mission: any) =>
    mission.months.flatMap((month: any) =>
      month.totaux.map((total: any) => total.name)
    )
  );
  const uniqueTotaux = [...new Set(totaux)];

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto mt-5">
      {production2?.clients?.map((client: any) => (
        <React.Fragment key={client.id}>
          <tr className="h-12 w-full mt-10">
            <th className="border border-gray-300 px-4 py-2 bg-thead text-left min-w-64 whitespace-nowrap">
              {client.name}
            </th>
          </tr>
          {client?.missions?.map((mission: any) => (
            <React.Fragment key={mission.id}>
              <tr className="h-12">
                <th className="border border-gray-300 px-4 py-2 bg-thead text-left min-w-64 whitespace-nowrap">
                  {mission.mission}
                </th>
                <th className="border border-gray-300 px-4 py-2 bg-thead text-left min-w-48">
                  Mois
                </th>
                {uniqueUsers.map((user) => (
                  <th
                    key={user}
                    className="border border-gray-300 px-4 py-2 bg-thead text-left max-w-16 min-w-16"
                  >
                    {user}
                  </th>
                ))}
                {uniqueTotaux.map((total) => (
                  <th
                    key={total}
                    className="border border-gray-300 px-4 py-2 bg-thead text-left w-10"
                  >
                    {total}
                  </th>
                ))}
              </tr>
              <tbody>
                {mission?.months?.map((month: any, index: any) => (
                  <tr key={`${mission.id}-${index}`} className="h-8">
                    <td className="min-w-64 border border-gray-300"></td>
                    <td className="border border-gray-300 px-4 py-2 text-left min-w-48">
                      {month.month} {month.year}
                    </td>
                    {uniqueUsers?.map((user) => {
                      // Récupére les données de l'utilisateur pour le mois actuel
                      const userData = month.collabs.find(
                        (collab: any) => collab.name === user
                      );
                      return (
                        <td
                          key={user}
                          className="border border-gray-300 px-4 py-2 text-left max-w-16 min-w-16"
                        >
                          {userData
                            ? userData.hours == 0
                              ? ""
                              : userData.hours
                            : ""}
                        </td>
                      );
                    })}
                    {uniqueTotaux?.map((total) => {
                      // Récupére les données du total pour le mois actuel
                      const totalData = month.totaux.find(
                        (tot: any) => tot.name === total
                      );
                      return (
                        <td
                          key={total}
                          className="border border-gray-300 px-4 py-2 text-left"
                        >
                          {totalData
                            ? totalData.amount == 0
                              ? ""
                              : formatComptableMaisPasTrop(totalData.amount)
                            : ""}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr className="border-gray-300 bg-gray-100 h-8">
                  <td className="min-w-64 border border-gray-300 pl-4">Totaux</td>
                  <td className="border border-gray-300 px-4 py-2 text-left"></td>
                  {mission?.collabs?.map((collab: any) => (
                    <td
                      key={collab.name}
                      className="border border-gray-300 px-4 py-2 text-left"
                    >
                      {collab.hours == 0 ? "" : collab.hours}
                    </td>
                  ))}
                  {mission?.totaux?.map((total: any) => (
                    <td
                      key={total.name}
                      className="border border-gray-300 px-4 py-2 text-left"
                    >
                      {total.amount == 0
                        ? ""
                        : formatComptableMaisPasTrop(total.amount)}
                    </td>
                  ))}
                </tr>
              </tbody>
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
      <tfoot className="w-full ">
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <>
            <td className="min-w-64 border border-gray-300 pl-4">
              Total des totaux
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left"></td>
            {uniqueUsers?.map((user) => {
              // Récupére les données de l'utilisateur pour le mois actuel
              const userData = production2?.totalCollabs?.find(
                (collab: any) => collab.name === user
              );
              return (
                <td
                  key={user}
                  className="border border-gray-300 px-4 py-2 text-left"
                >
                  {userData
                    ? userData.totalHours == 0
                      ? ""
                      : userData.totalHours
                    : ""}
                </td>
              );
            })}
            <td className="border border-gray-300 px-4 py-2 text-left min-w-44">
              {formatComptableMaisPasTrop(production2?.totaux?.valorisation.toFixed(2))}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left min-w-44">
              {formatComptableMaisPasTrop(production2?.totaux?.facturation.toFixed(2))}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left min-w-44">
              {formatComptableMaisPasTrop(production2?.totaux?.marge.toFixed(2))}
            </td>
          </>
        </tr>
      </tfoot>
    </table>
  );
};

export default TimeSpentPerCustomer;
